import React from 'react';
import ServiceTemplate from './ServiceTemplate';

export default function AnalisisExpedientes() {
  return <ServiceTemplate serviceName="analisis-expedientes" />;
}
